<main class="app_main__container app_agendas__container">

  <header class="app_agendas__header">
    <h2 class="app_agendas__header_title">Agenda</h2>
    <app-last-update (actualizarAgendas)="clearFiltro()" [isAgenda]="isAgenda"></app-last-update>
  </header>

  <div *ngIf="isConnected === true">
    <p-dataView #dv [filterBy]="filterBy" [value]="listaAgendas" [rows]="rows" [pageLinks]="0" [paginatorPosition]="'top'"
      [paginator]="true" [rowsPerPageOptions]="[5,10,20,30]" [showCurrentPageReport]="true" [currentPage]="currentPage"
      (onPage)="onPageChange($event)" [first]="currentPage"
      (onRowsPerPageChange)="onRowsPerPageChange($event)"
      [showFirstLastIcon]="false"
      currentPageReportTemplate="{first} - {last} de {totalRecords} agendas" emptyMessage=" ">

      <ng-template pTemplate="paginatorleft">

        <div style="display: flex">
          <div class="field-paginator-left">
            <div class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input (input)="actionFilter($event)" [(ngModel)]="inputSearch" id="search" name="seacrh" pInputText
                placeholder="Buscar" type="search">
            </div>
          </div>

          <div class="content_filter" style="display: flex; justify-content: flex-end; margin-top: 10px">

            <div
              style="display: flex;"
              (click)="showModalFilter()"
              >

              <div class="filter-icon">
                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 8C1.8 8 0 6.2 0 4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                  <path
                    d="M23 5H7c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1zm0 8h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm-10 0H1c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1zm-3 11c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                  <path
                    d="M23 21H13c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1zM7 21H1c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
                </svg>
              </div>

              <label class="filter-label">Filtros </label>
            </div>
            <label (click)="clearFiltro()" *ngIf="clearFilter" class="filter-label filter-clean">
              Limpiar Filtros
            </label>
          </div>
        </div>
      </ng-template>
      <ng-template let-agendas let-i="index" pTemplate="listItem">
        <div class="full-agendas">
          <app-agendas-card-item
            [card]="agendas"
            [isLastCardItem]="isLast && listaAgendas.length > 1"
            [estado]="estado"
            [currentPage]="currentPage">
          </app-agendas-card-item>
        </div>
      </ng-template>
      </p-dataView>
  </div>

  <div *ngIf="isConnected === true">
    <div *ngIf="listaAgendas.length==0 && !displaySpinner">
      <app-empty-state [subTittle]="'Todos los datos se enviaron correctamente'" [tittle]="'No hay Agendas'">
      </app-empty-state>
    </div>

    <div *ngIf="sinRegistroFilter">
      <app-empty-state [subTittle]="'La búsqueda no devolvió resultados'" [tittle]="'No se encontraron agendas'">
      </app-empty-state>
    </div>
  </div>
  
  <app-agendas-filter
    [display]="displayModal"
    (closeDialog)="closeModal()"
    (filterAgendas)="onFilterAgendas($event)"
    [clear]="clearFilter"
    (seeClearFilter)="seeClearFilter($event)">

  </app-agendas-filter>

  <div *ngIf="isConnected === false">
    <h1>Agendas</h1>
    <section>
      <p style="width:680px;">Estimado Prestador, la agenda solo se encuentra disponible de modo online.</p>
    </section>
  </div>
  <app-cx-spinner *ngIf="displaySpinner"></app-cx-spinner>
 </main>
